/**
 * EE 工作台菜单：复用 @Dashboard/router（CE），避免与 ceRouter 重复维护。
 */
import i18n from '@/locales'
import Dashboard from '@Dashboard/router'

const dashboardMenu = Dashboard.menu || (
  Dashboard.menus &&
  Dashboard.menus[0] &&
  Dashboard.menus[0].submenus &&
  Dashboard.menus[0].submenus[0]
)

export default {
  index: 1,
  meta: {
    label: i18n.t('dashboard.text_77'),
    icon: 'menu-dashboard',
  },
  menus: [
    {
      meta: {
        label: i18n.t('dashboard.text_77'),
      },
      submenus: dashboardMenu
        ? [{
          ...dashboardMenu,
          meta: {
            ...(dashboardMenu.meta || {}),
            label: i18n.t('dashboard.text_77'),
          },
        }]
        : [],
    },
  ],
}
